import React from "react";

interface GameItem {
  href: string;
  imgSrc: string;
  alt?: string;
  onClick?: () => void;
}

const games: GameItem[] = [
  {
    href: "/trickBacarat",
    imgSrc: "/assets/thuthuat.png",
  },
  {
    href: "/casino",
    imgSrc: "/assets/congthuc.png",
  },
];

const CustomLobby: React.FC = () => {
  return (
    <div className="relative w-full max-w-screen-xl mx-auto px-4" style={{marginBottom: '100px'}}>
      {/* Corner Videos */}
      {/* <div className="fixed top-5 left-0 w-64 h-64 z-0" style={{marginTop: '10px'}}>
        <video
          className="w-full h-full object-contain"
          src="/assets/casino/bgGameVideo.mp4"
          autoPlay
          loop
          muted
          playsInline
          controls={false}
        />
      </div>
      <div className="fixed top-5 right-0 w-64 h-64 z-0" style={{marginTop: '10px'}}>
        <video
          className="w-full h-full object-contain"
          src="/assets/casino/bgGameVideo.mp4"
          autoPlay
          loop
          muted
          playsInline
          controls={false}
        />
      </div>
      <div className="fixed bottom-0 left-0 w-64 h-64 z-0" style={{marginBottom: '-40px'}}>
        <video
          className="w-full h-full object-contain"
          src="/assets/casino/bgGameVideo.mp4"
          autoPlay
          loop
          muted
          playsInline
          controls={false}
        />
      </div>
      <div className="fixed bottom-0 right-0 w-64 h-64 z-0" style={{marginBottom: '-40px'}}>
        <video
          className="w-full h-full object-contain"
          src="/assets/casino/bgGameVideo.mp4"
          autoPlay
          loop
          muted
          playsInline
          controls={false}
        />
      </div> */}

      {/* Header */}
      <div className="flex justify-center items-center mb-8 relative z-10">
        <div className="max-w-xl">
          <img className="w-full" src="/assets/text_Lobby.png" alt="Lobby" />
        </div>
      </div>

      {/* Games Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-8 relative z-10">
        {games.map((game, index) => (
          <div
            key={index}
            className="cursor-pointer transition-transform hover:scale-105"
            onClick={game.onClick}
          >
            {game.onClick ? (
              <div>
                <figure className="overflow-hidden rounded-xl shadow-md">
                  <img
                    src={game.imgSrc}
                    alt={game.alt || ""}
                    className="w-full h-auto object-cover"
                  />
                </figure>
              </div>
            ) : (
              <a href={game.href}>
                <figure className="overflow-hidden rounded-xl shadow-md">
                  <img
                    src={game.imgSrc}
                    alt={game.alt || ""}
                    className="w-full h-auto object-cover"
                  />
                </figure>
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomLobby;
